<template>
  <form-wrapper :validator="$v.items">

    <div class="col-md-6">
      <h5 style="margin-bottom: 1em">
        {{ $t('message.zaplPrispevkyHeader') }}
        <img
          style="cursor: pointer;"
          v-b-modal.danBonusInfo
          src="@/assets/info.png" >
      </h5>
    </div>

    <b-form-row>
      <b-col
        v-for="(item, key) in cols"
        :key="key">
        <text-group
          v-for="(i, k) in item"
          :key="k"
          :m="items"
          :name="k"
          :label="i.label"
          :hint="i.hint" />
      </b-col>
    </b-form-row>

    <b-button
      class="btn-primary"
      @click="save">
      {{ $t('message.lblSave') }}
    </b-button>

    <b-modal
      id="danBonusInfo"
      :ok-only="true"
      :ok-title="$t('message.butBack')">

      <dan-bonus-info />

    </b-modal>

  </form-wrapper>
</template>

<script>
import { minValue, maxValue, decimal } from 'vuelidate/lib/validators';
import textGroup from '@/components/extractor/textGroup.vue';
import restEditor from '@/mixins/restEditor';
import danBonusInfo from '@/components/danBonusInfo.vue';

export default {
  components: {
    textGroup,
    danBonusInfo,
  },

  mixins: [restEditor],

  data() {
    const parent = this.$route.params.userId;
    return {
      parent,
      items: {
        parent,
        dopl_doch_spor: null,
        ks_danovnik: null,
        zd_uroky: null,
        porusenie_podmienok: null,
        zd_uver: null,
        zd_mesiac_uzatv_zmluvy: null,
      },
      database: {
        months: [
          { value: 0, text: 'neuplatňuje' },
          { value: 1, text: 'január / 2018' },
          { value: 2, text: 'február / 2018' },
          { value: 3, text: 'marec / 2018' },
          { value: 4, text: 'apríl / 2018' },
          { value: 5, text: 'máj / 2018' },
          { value: 6, text: 'jún / 2018' },
          { value: 7, text: 'júl / 2018' },
          { value: 8, text: 'august / 2018' },
          { value: 9, text: 'september / 2018' },
          { value: 10, text: 'október / 2018' },
          { value: 11, text: 'november / 2018' },
          { value: 12, text: 'december / 2018' },
        ],
      },
      cols: {
        col1: {
          zd_uver: { label: this.$t('message.lblUver') },
          zd_uroky: { label: this.$t('message.lblUroky') },
          zd_mesiac_uzatv_zmluvy: { label: this.$t('message.lblPocMesiac') },
        },
        col2: {
          porusenie_podmienok: { label: this.$t('message.lblPorusPod') },
          ks_danovnik: { label: this.$t('message.lblKs') },
          dopl_doch_spor: {
            label: this.$t('message.lblDds'),
            hint: this.$t('message.hintPrispevky'),
          },
        },
      },
    };
  },

  validations: {
    items: {
      dopl_doch_spor: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(180.00),
      },
      ks_danovnik: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(50),
      },
      zd_uroky: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(99999999.99),
      },
      porusenie_podmienok: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(99999999.99),
      },
      zd_uver: {
        decimal,
        minValue: minValue(0),
        maxValue: maxValue(99999999.99),
      },
      zd_mesiac_uzatv_zmluvy: {
        minValue: minValue(0),
        maxValue: maxValue(12),
      },
    },
  },

  methods: {
    async processGet() {
      this.items = await this.restDataSource.getData(this.parent, 'zd');
    },
    async processSave() {
      await this.restDataSource.updateData(this.items, 'zd');
    },
  },
};
</script>
